<app-insurance-section
  *ngIf="(insurance$ | async)?.primaryInsurance"
  title="Primary Insurance"
  [insurance]="(insurance$ | async)?.primaryInsurance!"
  updateButtonLabel="Update Primary Insurance"
  formTitle="Update Primary Insurance"
  [userData]="(insuranceUserData$ | async)?.primaryInsurance || null"
  [onSubmit]="onSubmitInsurance.bind(this, 'primaryInsurance')"
  data-cy="primary-insurance-section"
></app-insurance-section>

<div class="mt-3 sm:mt-6">
  <app-insurance-section
    *ngIf="(insurance$ | async)?.secondaryInsurance"
    title="Secondary Insurance"
    [insurance]="(insurance$ | async)?.secondaryInsurance!"
    updateButtonLabel="Update Secondary Insurance"
    formTitle="Update Secondary Insurance"
    [userData]="(insuranceUserData$ | async)?.secondaryInsurance || null"
    [onSubmit]="onSubmitInsurance.bind(this, 'secondaryInsurance')"
    data-cy="secondary-insurance-section"
  ></app-insurance-section>
</div>
<app-wizard-footer></app-wizard-footer>
